// extracted by mini-css-extract-plugin
export var container = "MeetYourShroomSingle-module--container--r21m-";
export var wrapper = "MeetYourShroomSingle-module--wrapper--s00vG";